import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig"; // your axios with interceptors
import config from "../../config/api"; // your API base URL config

const BackendURL = config.backendUrl;

export const assignProjectToOP = createAsyncThunk(
  "managerProjectAssign/assignProjectToOP",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${BackendURL}/project-assigned/assign-to-op`,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to assign project"
      );
    }
  }
);

export const reAssignProjectToOP = createAsyncThunk(
  "managerProjectAssign/reAssignProjectToOP",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${BackendURL}/project-assigned/operation-re-assign`,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to assign project"
      );
    }
  }
);

export const cancelOPResponseBeforeAssign = createAsyncThunk(
  "managerProjectAssign/reAssignProjectToOP",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${BackendURL}/managerProjectRequested/manager-action-cancel-track-before`,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to assign project"
      );
    }
  }
);

const managerProjectAssignSlice = createSlice({
  name: "managerProjectAssign",
  initialState: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  reducers: {
    resetAssignState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(assignProjectToOP.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(assignProjectToOP.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(assignProjectToOP.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })

      .addCase(reAssignProjectToOP.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(reAssignProjectToOP.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(reAssignProjectToOP.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { resetAssignState } = managerProjectAssignSlice.actions;
export default managerProjectAssignSlice.reducer;
